import { Component } from '@angular/core';

@Component({
  selector: 'app-media-coverage',
  templateUrl: './media-coverage.component.html',
  styleUrls: ['./media-coverage.component.scss',],
})
export class MediaCoverageComponent {

  constructor() { }

  mediaList = [
    {
      image: '../assets/images/landing-page/media-coverage/media1.png',
      sourceLogo: '../assets/images/landing-page/media-coverage/media1-logo.png',
      title: 'Used-car leasing firm PumPumPum raises $2 mn in equity funding',
      link: 'https://www.financialexpress.com/auto/car-news/auto-start-up-pumpumpum-on-an-expansion-drive/2310644/',
    },
    {
      image: '../assets/images/landing-page/media-coverage/media2.png',
      sourceLogo: '../assets/images/landing-page/media-coverage/media2-logo.png',
      title: 'Pumpumpum bets big big on leased vehicles',
      link: 'https://www.autocarpro.in/feature/pumpumpum-bets-big-on-leased-vehicles-81821',
    },
    {
      image: '../assets/images/landing-page/media-coverage/media3.png',
      sourceLogo: '../assets/images/landing-page/media-coverage/media3-logo.png',
      title: 'Used-car leasing firm PumPumPum raises $2 mn in equity funding',
      link: 'https://economictimes.indiatimes.com/tech/funding/pumpumpum-in-talks-to-raise-10-million-in-series-a-funds/articleshow/82184828.cms',
    },
    {
      image: '../assets/images/landing-page/media-coverage/media4.png',
      sourceLogo: '../assets/images/landing-page/media-coverage/media4-logo.png',
      title: 'Auto start-up: PumPumPum on an expansion drive',
      link: 'https://www.financialexpress.com/auto/car-news/auto-start-up-pumpumpum-on-an-expansion-drive/2310644/',
    },
  ];

  onClick(url: string) {
    window.open(url);
  }
}
